var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BarraCrud',{attrs:{"botaoNovo":true,"onNovo":_vm.novo,"onFiltrar":_vm.filtrar}}),_c('EmpresaTable',{ref:"empresaTableComp",attrs:{"filtro":_vm.filtro}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }